module.exports = __webpack_public_path__ + "assets/img/12.18de2fe3.png";